import TimeControl from './component'

export default TimeControl
